/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_Position_TheoreticalInputs */

const fr_help_position_theoretical = /** @type {(inputs: Help_Position_TheoreticalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Théorique`)
};

const en_help_position_theoretical = /** @type {(inputs: Help_Position_TheoreticalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scheduled`)
};

/**
* | output |
* | --- |
* | "Scheduled" |
*
* @param {Help_Position_TheoreticalInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const help_position_theoretical = /** @type {((inputs?: Help_Position_TheoreticalInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Help_Position_TheoreticalInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_help_position_theoretical(inputs)
	return en_help_position_theoretical(inputs)
});